import React from 'react';

const TrashPageConfig = {
	settings: {
		layout: {
			config: {
				adminPage: true,
			},
		},
	},
	routes: [
		{
			path: '/admin/trash',
			exact: true,
			component: React.lazy(() => import('./TrashPage')),
		},
	],
};

export default TrashPageConfig;
